import EnumSet from 'Services/enumSet'

interface IUserPhoneTypes extends EnumSet {
  none: number
  unverified: number
  verified: number
  expired: number
}

const UserPhoneTypes = new EnumSet({
  none: { value: 0, description: 'Indefinido' },
  unverified: { value: 1, description: 'Não verificado' },
  verified: { value: 2, description: 'Verificado' },
  expired: { value: 3, description: 'Expirado' },
}) as IUserPhoneTypes

export default UserPhoneTypes